import { Bookmark, Chat, Heart, InstagramLogo } from '@phosphor-icons/react/dist/ssr';

import { appendProtocol } from '@/postContentElement/components/utils/link';
import { usePostContentContext } from '@/postContentElement/context';
import { evaluateAndAppendUTMParams } from '@/utils/evaluateAndAppendUTMParams';

interface Props {
  anchorId?: string;
  postUrl?: string;
  authorProfileImage?: string;
  authorName?: string;
  displayFollowerCount?: boolean;
  followersDisplay?: string;
  thumbnailUrl?: string;
  displayMetrics?: boolean;
  metricsDisplay?: string;
  description?: string;
  logoImageUrl?: string;
  screenshotUrl?: string;
}

const Instagram = ({
  anchorId,
  postUrl,
  authorProfileImage,
  authorName,
  displayFollowerCount,
  followersDisplay,
  thumbnailUrl,
  displayMetrics,
  metricsDisplay,
  description,
  screenshotUrl,
}: Props) => {
  const { utmParams } = usePostContentContext();
  const postUrlWithUTMParams = evaluateAndAppendUTMParams(appendProtocol(postUrl), utmParams);

  return (
    <div
      id={anchorId}
      className="bh__ig_wrapper"
      style={{
        padding: '0.5rem 0.25rem',
      }}
    >
      <blockquote
        className="bh__ig_media mx-auto p-0 border border-[#d1d5db] bg-white hover:bg-[#f9fafb]"
        style={{
          maxWidth: '420px',
          minWidth: '326px',
          width: 'calc(100% - 2px)',
          borderRadius: '0.5rem',
        }}
      >
        <div>
          {screenshotUrl ? (
            <a
              href={postUrlWithUTMParams}
              className="p-0 text-center w-full no-underline"
              target="_blank"
              rel="noreferrer"
            >
              <img src={screenshotUrl} alt="Instagram post" />
            </a>
          ) : (
            <a href={postUrlWithUTMParams} target="_blank" className="p-0 text-center no-underline	" rel="noreferrer">
              <div className="flex items-center" style={{ padding: '0.75rem' }}>
                {authorProfileImage && (
                  <div className="grow-0" style={{ marginRight: '0.75rem' }}>
                    <img
                      src={authorProfileImage}
                      className="w-[40px] h-[40px] border-0 block rounded-lg"
                      alt={authorName}
                    />
                  </div>
                )}
                <div>
                  <p className="text-left" style={{ lineHeight: 1.5, color: 'rgba(31,41,55,1)' }}>
                    <strong>{authorName}</strong>
                  </p>
                  {displayFollowerCount && (
                    <p
                      className="text-left"
                      style={{ lineHeight: 1.5, fontSize: '0.875rem', color: 'rgba(107,114,128,1)' }}
                    >
                      {followersDisplay}
                    </p>
                  )}
                </div>
              </div>
              <div className="bh__ig_image_wrapper relative border-b border-t border-[#d1d5db]">
                <img alt={description} src={thumbnailUrl} className="block h-auto max-w-full border-0" />
              </div>
              <div style={{ padding: '0.75rem' }}>
                <p className="text-[#0095f6] text-center" style={{ lineHeight: 1.5 }}>
                  <strong>View more on Instagram</strong>
                </p>
              </div>

              <div style={{ paddingLeft: '1rem', paddingRight: '1rem' }}>
                <div className="border-t border-[#d1d5db] w-full" />
                <div className="flex items-center" style={{ paddingTop: '0.5rem', paddingBottom: '1rem' }}>
                  {/* Heart */}
                  <Heart size={14} />

                  {/* Comment Bubble */}
                  <Chat size={14} />

                  {/* Bookmark */}
                  <Bookmark size={14} />
                </div>
                <div style={{ marginBottom: '1rem' }}>
                  {displayMetrics && <p className="text-left color-[#1f2937]">{metricsDisplay}</p>}
                  <p className="text-left color-[#1f2937]">
                    <strong>{authorName}</strong>
                  </p>
                  {description && (
                    <div
                      className="text-left color-[#1f2937]"
                      style={{ paddingTop: '0.75rem', paddingBottom: '0.75rem' }}
                    >
                      {description}
                    </div>
                  )}
                </div>
              </div>
              <div className="border-t border-[#d1d5db] w-full" />
              <div className="flex justify-between items-center" style={{ padding: '0.75rem' }}>
                <div className="color-[#6b7280]" style={{ fontSize: '0.875rem', lineHeight: '1.25rem' }}>
                  Add a comment...
                </div>
                <div>
                  <InstagramLogo size={20} />
                </div>
              </div>
            </a>
          )}
        </div>
      </blockquote>
    </div>
  );
};

export { Instagram };
